import { render, staticRenderFns } from "./ProductScanner.vue?vue&type=template&id=2206d756&scoped=true"
import script from "./ProductScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductScanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductScanner.vue?vue&type=style&index=0&id=2206d756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206d756",
  null
  
)

export default component.exports